import React from "react";
import Modal from "../index";
import { FlexContainer, Img, Text } from "../../../design";
import success from "../../../assets/imgs/success.svg";

type Props = {
    isOpen: Boolean,
    successMsg: String,
}

const SuccessMessageModal = (props: Props) => {
    return (
        <Modal isOpen={props.isOpen}>
            <FlexContainer
                height="200px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
                box-shadow="0 0 20px 0 rgba(0, 0, 0, 0.1)"
                backdropFilter='none'
                borderRadius='4px'
                backgroundColor="#f2f5f8"
                textAlign='center'
                alignContent='none'
            >
                <Img width='108px' height='108px' paddingBottom='16px' src={success} />
                <Text 
                    fontSize="16px"
                    fontWeight="400"
                    color="#333"
                    maxWidth="300px"
                    lineHeight="1.5"
                    textAlign="center"
                    paddingX="14px"
                >
                    {props.successMsg}
                </Text>
            </FlexContainer>
        </Modal>
    )
};

export default SuccessMessageModal;